export default "__VITE_ASSET__c94eff91__"